import httpDao from "@/infrastructure/httpDao";

export const TICKETING_SETTING_CHANGED_EVENT =
  "sumacomi:ticketing-settings-changed";

export type TicketingFacilityScope = "ALL" | "SELECTED";
export type TicketProductStatus = "DRAFT" | "ACTIVE" | "ENDED";
export type TicketProductUsageScope = "ACCOUNT_HOLDER" | "LINKED_PROFILES";
export type TicketProductExpiryPolicy =
  | "PURCHASE"
  | "FIRST_USE"
  | "FIXED"
  | "NONE";
export type TicketProductAudience = "MEMBER" | "PUBLIC" | "INVITE";

export type TicketingSetting = {
  organizationId: string;
  enabled: boolean;
  facilityScope: TicketingFacilityScope;
  /** 設定未作成時はnull。更新時の競合検知にそのまま返す。 */
  updatedAt: string | null;
  facilities: Array<{
    facilityId: string;
    facility: { id: string; name: string };
  }>;
};

export type TicketProduct = {
  id: string;
  name: string;
  description: string | null;
  usageScope: TicketProductUsageScope;
  quantity: number;
  price: number;
  ticketsPerBooking: number;
  expiryPolicy: TicketProductExpiryPolicy;
  expiryDays: number | null;
  fixedExpiryDate: string | null;
  audience: TicketProductAudience;
  salesStartAt: string | null;
  salesEndAt: string | null;
  purchaseLimit: number | null;
  cancelDeadlineHours: number;
  returnOnCancel: boolean;
  consumeOnNoShow: boolean;
  status: TicketProductStatus;
  salesFacility: { id: string; name: string } | null;
  facilities: Array<{
    facilityId: string;
    facility: { id: string; name: string };
  }>;
  courses: Array<{
    courseId: string;
    course: { id: string; name: string };
  }>;
};

export type SaveTicketProductInput = {
  salesFacilityId: string;
  facilityIds: string[];
  courseIds: string[];
  name: string;
  description?: string;
  usageScope: TicketProductUsageScope;
  quantity: number;
  price: number;
  ticketsPerBooking: number;
  expiryPolicy: TicketProductExpiryPolicy;
  expiryDays?: number;
  fixedExpiryDate?: string;
  audience: TicketProductAudience;
  salesStartAt?: string;
  salesEndAt?: string;
  purchaseLimit?: number;
  cancelDeadlineHours: number;
  returnOnCancel: boolean;
  consumeOnNoShow: boolean;
  status: TicketProductStatus;
};

export const ticketingRepository = {
  getSetting: async (): Promise<TicketingSetting> => {
    const response = await httpDao.get<TicketingSetting>(
      "/admin/ticketing/setting"
    );
    return response.data;
  },

  updateSetting: async (input: {
    expectedUpdatedAt: string | null;
    enabled: boolean;
    facilityScope: TicketingFacilityScope;
    facilityIds: string[];
  }): Promise<TicketingSetting> => {
    const response = await httpDao.put<TicketingSetting>(
      "/admin/ticketing/setting",
      input
    );
    return response.data;
  },

  listProducts: async (): Promise<TicketProduct[]> => {
    const response = await httpDao.get<TicketProduct[]>(
      "/admin/ticketing/products"
    );
    return response.data;
  },

  createProduct: async (
    input: SaveTicketProductInput
  ): Promise<TicketProduct> => {
    const response = await httpDao.post<TicketProduct>(
      "/admin/ticketing/products",
      input
    );
    return response.data;
  },
};
